__turbopack_context__.v({
  "clearButton": "FiltersSearch-module-scss-module__F-L0BW__clearButton",
  "form": "FiltersSearch-module-scss-module__F-L0BW__form",
  "root": "FiltersSearch-module-scss-module__F-L0BW__root",
  "searchButton": "FiltersSearch-module-scss-module__F-L0BW__searchButton",
});
